import React from "react";
import './cardBenefit.scss';
function Card(props) {
  const { image, text, stylesCard, number, borderTop, className } = props;

  return (
    <div className={className ? className : "cardBenefit"} style={stylesCard}>
      {borderTop && <div className = "cardBenefit-borderTop"></div>}
      <div className="cardBenefit-number"><span>{number}</span></div>
      <div className="cardBenefit-content">
        <img src={image} alt={image} />
        {props.children}
      </div>
    </div>
  );
}

export default Card;